import {
  CRITICALITIES,
  CRITICALITIES_DISPLAY_NAME,
} from '../enums/criticalities-enum.enum';
import criticalityLow from '../assets/images/icons/reserve-reasons/criticalities/low.png';
import criticalityMedium from '../assets/images/icons/reserve-reasons/criticalities/medium.png';
import criticalityHigh from '../assets/images/icons/reserve-reasons/criticalities/high.png';
import criticalityUrgent from '../assets/images/icons/reserve-reasons/criticalities/urgent.png';
import { STATUS_ENUM } from '../components/agv-status/status-enum';

export function getCriticalityImg(criticality) {
  switch (criticality) {
    case CRITICALITIES.LOW:
      return <img src={criticalityLow} className="tw-w-4 tw-h-4" alt="low" />;
    case CRITICALITIES.MEDIUM:
      return (
        <img src={criticalityMedium} className="tw-w-4 tw-h-4" alt="medium" />
      );
    case CRITICALITIES.HIGH:
      return <img src={criticalityHigh} className="tw-w-4 tw-h-4" alt="high" />;
    case CRITICALITIES.URGENT:
      return (
        <img src={criticalityUrgent} className="tw-w-4 tw-h-4" alt="urgent" />
      );
  }
}

export function returnCriticalityDiv(criticality) {
  return (
    <div>
      {getCriticalityImg(criticality)}
      {CRITICALITIES_DISPLAY_NAME[criticality]}
    </div>
  );
}

export function getCriticalityStatus(criticality) {
  switch (criticality) {
    case CRITICALITIES.URGENT:
      return STATUS_ENUM.NEGATIVE;
    case CRITICALITIES.HIGH:
      return STATUS_ENUM.NEGATIVE;
    case CRITICALITIES.MEDIUM:
      return STATUS_ENUM.WARN;
    case CRITICALITIES.LOW:
      return STATUS_ENUM.INFO;
    default:
      return STATUS_ENUM.NEUTRAL;
  }
}
